module.exports = __webpack_public_path__ + "img/hourglass.549947b6.gif";